import styled from 'styled-components';

export const Card = styled.div<{ $clickable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  min-height: 60px;
  max-height: 60px;
  padding: ${({ theme }) => theme.spacing.ms};
  background-color: ${({ theme }) => theme.colors.background};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  box-shadow: ${({ theme }) => theme.shadows.md};
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
  transition: all 0.2s ease;
  outline: none;

  /* ホバー状態 */
  &:hover {
    background-color: ${({ theme, $clickable }) =>
      $clickable ? theme.colors.backgroundSecondary : theme.colors.background};
  }

  /* フォーカス状態（キーボードナビゲーション用） */
  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
    box-shadow: 0px 4px 12px 2px rgba(0, 169, 96, 0.2);
  }

  /* アクティブ状態 */
  &:active {
    transform: ${({ $clickable }) => ($clickable ? 'scale(0.98)' : 'none')};
  }
`;

export const CardLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0; 
  pointer-events: none;
`;

export const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  pointer-events: none;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  flex: 1;
  pointer-events: none;
`;

export const Label = styled.span<{ $hasMinWidth?: boolean }>`
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
  pointer-events: none;

  min-width: ${({ $hasMinWidth }) => ($hasMinWidth ? '64px' : 'auto')};
`;

export const SubArea = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const SubLabel = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.colors.text.secondary};
  white-space: nowrap;
  pointer-events: none;
`;

export const Value = styled.div<{ $isSmallFontSize?: boolean }>`
  font-size: ${({ $isSmallFontSize, theme }) => ($isSmallFontSize ? theme.typography.fontSize.xl : theme.typography.fontSize.xxl)};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 1;
  pointer-events: none;
`;

export const Unit = styled.span`
  font-size: 15px;
  color: #666; /* WCAG AA準拠: 白背景で5.74:1のコントラスト比 */
  font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
  pointer-events: none;
`;

export const ArrowIconWrapper = styled.span`
  font-size: 30px;
  line-height: 2;
  pointer-events: none;
  margin-left: auto;
`;
